import { render, staticRenderFns } from "./AquaSubjectForms.vue?vue&type=template&id=2ccab66d&scoped=true&"
import script from "./AquaSubjectForms.vue?vue&type=script&lang=js&"
export * from "./AquaSubjectForms.vue?vue&type=script&lang=js&"
import style0 from "./AquaSubjectForms.vue?vue&type=style&index=0&id=2ccab66d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccab66d",
  null
  
)

export default component.exports